import React from "react";
import { type SVGComponentProps } from "../../../../types/Svgs";

const StartPointIcon: React.FC<SVGComponentProps> = ( { primaryColor, secondaryColor, size } ) => {
    return (
        <div>
            <svg
                fill="none"
                height={size != null ? size[1].toString() : "17"}
                viewBox="0 0 17 17"
                width={size != null ? size[0].toString() : "17"}
                xmlns="http://www.w3.org/2000/svg"
            >
                <style>
                    {`
            .primaryCar { stroke: ${ primaryColor != null ? primaryColor : "#76919B" } }
            .secondaryCar { fill: ${ secondaryColor != null ? secondaryColor : "grey" } }
          `}
                </style>
                <circle
                    className="primaryCar"
                    cx="8.17236"
                    cy="8.74316"
                    fill="#fff"
                    r="5.5"
                    strokeWidth="5"
                />
            </svg>
        </div>
    );
};

export default StartPointIcon;
